var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:['btn-loader', _vm.btnLoaderSizeClass],attrs:{"src":require("@/components/common/buttons/loader.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }